import React, { useEffect, useState, useRef } from "react"
import { useTranslation } from "react-i18next"
import {
  Row,
  Col,
  CardBody,
  Card,
  Input,
  Container,
  Button,
  InputGroup,
  CardTitle,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ButtonGroup,
} from "reactstrap"
import DataTable from "react-data-table-component"
import AsyncSelect from "react-select/async"
import service from "../../api/monitor.service"
import "./user.scss"
//redux
import { useSelector, useDispatch } from "react-redux"
import { Link } from "react-router-dom"
// actions
import {
  getUserListByType,
  updateStatus,
  cleanOrders,
  updateUsers
} from "../../store/actions"
import LinearIndeterminate from "../../components/Common/LinearIndeterminate"
import SessionConfig from "../../config/session_config"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import showToast from "../../components/Common/viewNotification"
import { is_empty } from "../../config/validate"
const Users = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const ref = useRef()
  const [page, setPage] = useState(0)
  const [size, setSize] = useState(10)
  const [modal, setModal] = useState(false)
  const [selectedRows, setSelectedRows] = useState([])
  const [filter, setFilter] = useState("")
  const [toggleCleared, setToggleCleared] = useState(false)
  const [toggleSwitch, settoggleSwitch] = useState(true)
  const [currentUser, setCurrentUser] = useState(null)
  const [supplier, setSupplier] = useState({
    value: 0,
    label: t("monitor:supplierFind"),
  })
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))
  // header title
  document.title = t("users:title") + " | " + t("global:title")

  const loadUserList = () => {
    const obj = {
      filter: filter,
      status: toggleSwitch ? "1" : "0",
      length: size,
      page: page,
      supplierId: supplier?.id,
      username: auth?.id?.user?.username,
    }
    dispatch(getUserListByType(obj))
  }

  const { error, users, loading, msg, loadingSupplier, response } = useSelector(state => {
    return {
      error: state.Users.error,
      loading: state.Users.loading,
      users: state.Users.users,
      msg: state.Users.msg,
      loadingSupplier: state.SupplierMonitor.loading,
      response: state.Users.response,
    }
  })

  useEffect(() => {
    if (response) {
      showToast(t("users:msgSuccess"), "success", t("users:tittleMsgSucces"))
      loadUserList();
    }
  }, [response])
  useEffect(() => {
    if (!is_empty(error)) {
      showToast(error, "error", t("error:title"))
    }
  }, [error])

  useEffect(() => {
    loadUserList()
  }, [toggleSwitch, page, size])

  useEffect(() => {
    if (msg.type) {
      showToast(msg.text, msg.type)
      loadUserList()
    }
  }, [msg.type])
  useEffect(() => {
    document.getElementById("body").className = "fondo2"
  }, [])
  const columns = [
    {
      name: t("users:user"),
      selector: row => row.name,
      sortable: false,
      grow: 3,
      reorder: true,
      // eslint-disable-next-line react/display-name
      cell: row => (
        <div>
          <i className="fa fa-user me-1 text-muted" />
          <span className="text-capitalize ">{row.name}</span>
        </div>
      ),
    },
    {
      name: t("users:positionWork"),
      selector: row => row.positionWork,
      sortable: false,
      grow: 1,
      reorder: true,
      cell: row => (
        <div>
          <span className="text-uppercase text-primary ">
            {row.positionWork}
          </span>
        </div>
      ),
    },
    {
      name: t("users:company"),
      selector: row => (row.supplier ? row.supplier.name : ""),
      sortable: false,
      grow: 3,
      reorder: true,
      cell: row => (
        <div>
          <span className=" text-muted ">{row.supplier?.name}</span>
          {row.supplier ? (
            <div>
              <Badge color="primary">
                {t("users:code") + " " + row.supplier?.code}
              </Badge>
            </div>
          ) : null}
        </div>
      ),
    },
    {
      name: t("users:account"),
      selector: row => row.username,
      sortable: false,
      grow: 2,
      reorder: true,
      cell: row => (
        <div>
          <span className=" text-muted ">{row.username}</span>
        </div>
      ),
    },
    !toggleSwitch ?
      {
        name: "Accion",
        cell: row => (
          <div className="d-flex gap-3">
            <Link className="text-fail" to="#">
              <i
                className="fa fa-trash trash-color"
                id="edittooltip"
                onClick={() => handleChangeStatus(row)}
              ></i>
            </Link>
          </div>
        ),
      } : <> </>
  ]
  const handleChangeStatus = row => {
    setCurrentUser(row)
    toggle()
  }
  const toggle = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }
  const changeTableSelect = React.useCallback(state => {
    setSelectedRows(state.selectedRows)
  }, [])

  const changeStatus = async () => {
    // await changeStatusCognito(selectedRows, toggleSwitch ? 0 : 1)
    await setToggleCleared(true)
    await dispatch(
      updateStatus({
        users: selectedRows,
        status: toggleSwitch ? 0 : 1,
        userPermission: auth?.id?.user?.username,
      })
    )
    await setToggleCleared(false)
  }

  const handlePerRowsChange = async (perPage, page) => {
    let pageRows = parseInt(page) - 1
    if (pageRows < 0) {
      pageRows = 0
    }
    await setPage(pageRows)
    await setSize(perPage)
  }
  const handlePageChange = async page => {
    let pageRows = parseInt(page) - 1
    if (pageRows < 0) {
      pageRows = 0
    }
    await setPage(pageRows)
  }
  const loadSuppliers = filter => {
    if (auth) {
      const json = {
        username: auth?.id?.user?.username,
        length: 30,
        filter,
        societyCode: process.env.REACT_APP_STYLE_TEMPLATE,
      }
      return service.getSupplier(json)
    }
  }
  const loadingOptionSupplier = async (filter, callback) => {
    if (filter.length >= 3) {
      const data = await loadSuppliers(filter)

      const s = data?.data?.map(item => {
        return {
          ...item,
          value: item.code,
          label: item.name + " | " + item.code,
        }
      })
      callback(s)
    }
  }
  const onChangeSupplier = (value, action) => {
    setSupplier(value)
    if (action.action === "clear") {
      dispatch(cleanOrders())
    }
  }
  const changeStatusUser = async () => {
    await dispatch(updateUsers(currentUser));
    toggle();
  }

  return (
    <React.Fragment>
      <SessionConfig ref={ref} />
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={t("global:title")}
            breadcrumbItem={t("users:title")}
          />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <CardTitle className="h5 mb-4 text-primary">
                    {t("monitor:filter")}
                  </CardTitle>
                  <Row mb="5">
                    <Col lg={12}>
                      <Row>
                        <Col>
                          <div className="form-check form-switch mb-3 ">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customSwitch2"
                              defaultChecked={toggleSwitch}
                              onClick={e => {
                                settoggleSwitch(e?.target?.checked)
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customSwitch2"
                            >
                              {t("users:noInactive")}
                            </label>
                          </div>
                        </Col>
                        <Col>
                          <div className="col-sm-auto min-Width-300">
                            <AsyncSelect
                              loadOptions={loadingOptionSupplier}
                              maxMenuHeight={150}
                              cacheOptions
                              className="small-font text-uppercase"
                              isDisabled={loading}
                              placeholder={t("users:searchSupplier")}
                              name="supplier"
                              isClearable
                              isLoading={loadingSupplier}
                              onChange={(value, action) => {
                                onChangeSupplier(value, action)
                              }}
                            />
                          </div>
                        </Col>
                        <Col>
                          <div className="mb-3  min-Width-300">
                            <InputGroup>
                              <Input
                                id="exampleSelect"
                                name="search"
                                type="text"
                                placeholder={
                                  t("global:Search") +
                                  " " +
                                  t("users:placeholderSearch")
                                }
                                onChange={value => {
                                  setFilter(value.currentTarget.value)
                                }}
                              ></Input>
                              <Button
                                color="primary"
                                disabled={loading}
                                onClick={loadUserList}
                              >
                                <i className=" fas fa-search me-1 " />
                              </Button>
                            </InputGroup>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <Col>
                          <div className="text-sm-end">
                            <Button
                              disabled={loading}
                              onClick={changeStatus}
                              color={toggleSwitch ? "danger" : "primary"}
                            >
                              <i className=" fas fa-times-circle me-1 " />
                              {!toggleSwitch
                                ? t("users:enabled")
                                : t("users:disabled")}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <DataTable
                    columns={columns}
                    data={users.users}
                    fixedHeader
                    fixedHeaderScrollHeight="500px"
                    dense
                    selectableRows
                    onSelectedRowsChange={changeTableSelect}
                    highlightOnHover
                    progressPending={loading}
                    pointerOnHover={true}
                    clearSelectedRows={toggleCleared}
                    progressComponent={<LinearIndeterminate />}
                    pagination
                    paginationServer
                    paginationTotalRows={users?.size}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    noDataComponent={t("tableOptions:noDataComponent")}
                    paginationComponentOptions={{
                      rowsPerPageText: t("tableOptions:rowsPerPageText"),
                      rangeSeparatorText: t("tableOptions:rangeSeparatorText"),
                      selectAllRowsItem: true,
                      selectAllRowsItemText: t(
                        "tableOptions:selectAllRowsItemText"
                      ),
                    }}
                  />
                  <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
                    <ModalHeader toggle={toggle} tag="h4" close={<span></span>}>
                      {t("users:message_title_status")}
                    </ModalHeader>
                    <ModalBody>
                      <Col>
                        <div >
                          {t("users:message_change_status")}
                        </div>
                      </Col>
                      <Col>
                        <div className="text-end">
                          <ButtonGroup>
                            <Button
                              type="submit"
                              className="btn btn-info save-user"
                              onClick={() => {
                                changeStatusUser()
                              }}
                            >
                              <i className=" fas fa-save me-1 "> {"  "}</i>
                              {t("supplier:btnModalSave")}
                            </Button>
                            <button
                              type="button"
                              className="btn btn-danger "
                              onClick={() => {
                                toggle(false)
                              }}
                            >
                              {" "}
                              {t("global:close")}
                            </button>
                          </ButtonGroup>
                        </div>
                      </Col>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Users
